import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'expiryMonitoring';

const expiryMonitoringService = {
  getExpiringFields: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/expiringFields`,
    });
  },

  getExpiringFieldsCount: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/expiringFields/count`,
    });
  },
};

export default expiryMonitoringService;
